import { createContext, useContext } from "react";

const BatchEditContext = createContext({
  open: false,
  handleOpen: () => null,
  handleClose: () => null,
  selectedIds: [],
  setSelectedIds: () => null,
  toggleSelected: () => null,
  clearAll: () => null,
  selectedAttributes: null,
  setSelectedAttributes: () => null,
});

export const BatchEditContextProvider = BatchEditContext.Provider;
export const BatchEditContextConsumer = BatchEditContext.Consumer;

export const useBatchEditContext = () => useContext(BatchEditContext);

export default BatchEditContext;
